import React, { Fragment, useContext, useState,useEffect } from "react";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../../Common/Component/ActionOptions";
import { Breadcrumbs, Spinner } from "../../../AbstractElements";
import DataTable from "react-data-table-component";
import CustomizerContext from "../../../_helper/Customizer";
import { DriverTypeColumns } from "../../../Data/Driver/DriverType";
import SharedDataContext from "../../../_helper/SharedData";
import { deleteDriverType, getDriverTypeAllCity, getDriverTypeTable, getDriverTypeWalletAllSearch } from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
import DriverSchemeEdit from "../EditForms/DriverSchemeEdit";
import DriverSchemeMinimumEdit from "../EditForms/DriverSchemeMinimumEdit";
import TariffModal from "../../../CommonElements/TariffModal/TariffModal";
import SearchTable from "../../Common/Component/SearchTable";
import FilterTable from "../../Common/Component/FilterTable";
import moment from "moment";
// import { Breadcrumbs } from "../../../AbstractElements";


function DriverTypeTable({}) {
  const { globalCityField } = useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(40);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const { mix_background_layout } = useContext(CustomizerContext);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isModal,setIsModal] = useState(false)
  const [editModal,setEditModal] = useState(false)
  const [isSearch, setIsSearch] = useState(true);
  const [editId,setEditId] = useState(null)
 const [minimumEdit, setminimumEdit] = useState({})
  const [searchData, setSearchData] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterData, setFilterData] = useState([]);


  const toggleModal=(editId)=>{
    setEditId(editId)
    setIsModal(!isModal)
  }
  const closeModal = ()=>{
    setIsModal(!isModal)
  }
  // -------------minimum edit table
  const toggleEditModal=(id,driverSchemeName)=>{
    setminimumEdit({id,driverSchemeName})
    setEditModal(!editModal)
  }
  const closeEditModal = ()=>{
    setEditModal(!editModal)
  }

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const disableLoaders = () => {
    setLoader(false);
  };

  const triggerRefresh = () => {
    setIsRefresh(!isRefresh);
  };

  useEffect(() => {
    fetchTableData();
  }, [globalCityField.value, pagination, rowsPerPage, isRefresh,searchData]);

  const fetchTableData = () => {
    const serviceCityId = globalCityField.value?globalCityField.value.id:0;
    if(searchData && filterType == "search"){
      let obj = {
        key:searchData,
        serviceCityId: serviceCityId,
      };
      setLoader(true);
      getDriverTypeWalletAllSearch(obj).then((resp)=>{
        setPaginationTotalRows(resp.data.count)
        setTableData(resp.data.searchResponse)
        setLoader(false)
      }).catch((err)=>{
        disableLoaders();
        showAlert("error","Can't able to Search Data")
      })
    }else{
    setLoader(true);
    getDriverTypeTable(serviceCityId).then((resp)=>{
      setPaginationTotalRows(resp.data.count)
      setTableData(resp.data.searchResponse)
      setLoader(false)
    }).catch((err)=>{
      disableLoaders();
      showAlert("error","Can't able to Fetch Data")
    })
  //  }else{
  //   getDriverTypeAllCity(serviceCityId).then((resp)=>{
  //     setPaginationTotalRows(resp.data.count)
  //     setTableData(resp.data.searchResponse)
  //     setLoader(false)
  //   }).catch((err)=>{
  //     disableLoaders();
  //     showAlert("error","Can't able to Fetch Data")
  //   })
  //  }
}
  };

  const conditionalRowStyles = [

    {
      when: row => row["Deleted"] ,
      style: row => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : ""}),
    },
];

  const isDeleteUpdate=(driverTypeId,isDelete)=>{
    let obj = {
        driverTypeId:driverTypeId,
        isDeleted:isDelete
    }

    deleteDriverType(obj).then((resp)=>{
      showAlert("success","Driver Type deleted")
      triggerRefresh()
    }).catch((err)=>{
      showAlert("error",err.message)
    })
    
  }

  const processData = tableData.map((element, index) => {
    return {
      name: element.driverSchemeName ? element.driverSchemeName : "",
      subscription: element.isSubscription ? "True" : "False",
      serviceCity: element.serviceCityName ? element.serviceCityName : "",
      applicableFrom: element.applicableFrom ?moment(new Date( element.applicableFrom)).format("MMM DD YY HH:mm" ) : "-",
      applicableTo: element.applicableTo ?moment(new Date( element.applicableTo)).format("MMM DD YY HH:mm" ) : "-",
      minimumBalance: element.minimumBalance
        ? element.minimumBalance
        : "-",
      Deleted: element.isDeleted,
      action: (
        <ActionOptions key={index}>
          <Fragment>
            
            <DropdownItem
              className="border-0"
              // key={"row-edit"}
              onClick={() => {
                toggleModal(element.driverTypeId)
              }}
            >
             <i class="fa fa-pencil" ></i>{" "}
              {"edit"}
            </DropdownItem>
            <DropdownItem
              className="border-0"
              // key={"row-edit"}
              onClick={() => {
                toggleEditModal(element.id,element.driverSchemeName)
              }}
            >
             <i class="fa fa-pencil" ></i>{" "}
              {"edit minimum balance"}
            </DropdownItem>
            <DropdownItem
              className="border-0"
              key={"row-edit"}
              onClick={() => {
                isDeleteUpdate(element.driverTypeId,element.isDeleted?false:true)
              }}
            >
              <i className="fa fa-trash-o"></i>{" "}
              {element.isDeleted ? "Recover" : "Delete"}
            </DropdownItem>
          </Fragment>
        </ActionOptions>
      ),
    };

  });

  return (
  <div className="driver-type-table">
    <Breadcrumbs
     parent="Configuration"
     subParent="Packages"
     mainTitle="Packages"
     span3={
       <SearchTable
         searchData={searchData}
         setSearchData={setSearchData}
         setFilterData={setFilterData}
         setFilterType={setFilterType}
         />
     }

    />
    <div className="table-responsive">
      <DataTable
        columns={DriverTypeColumns}
        data={processData}
        fixedHeader
        fixedHeaderScrollHeight={"57vh"}
        pagination
        // paginationPerPage={paginationPerPage}
        paginationTotalRows={paginationTotalRows}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationServer
        progressPending={loader}
        triggerRefresh={triggerRefresh}
        conditionalRowStyles={conditionalRowStyles}
        progressComponent={
          <div className="loader-box" style={{ height: "57vh" }}>
            <Spinner
              attrSpinner={{
                className: "loader-3",
                style: {
                  width: "30px",
                  height: "30px",
                  borderColor: "#39B54A",
                  borderBottomColor: "transparent",
                },
              }}
            />
          </div>
        }
        theme={mix_background_layout == "dark-only" ? "dark" : "default"}
      />
    </div>
    <DriverSchemeEdit closeModal={closeModal} editId={editId} isModal={isModal} triggerRefresh={triggerRefresh}/>
   
    <TariffModal
      isOpen={editModal}
      size="xl"
      centered
      toggler={closeEditModal}
      title={"Wallet Minimum Balance"}
      >
    <DriverSchemeMinimumEdit closeModal={closeEditModal} obj={minimumEdit} isModal={editModal} triggerRefresh={triggerRefresh}/>

    </TariffModal>
  </div>
  );
}

export default DriverTypeTable;
